{
    "ai": {
        "usage": {
            "emptyState": "Aucune utilisation enregistrée pour le moment.",
            "totalTokens": "Jetons totaux",
            "estimatedCost": "Coût estimé",
            "sessions": "Sessions",
            "inputTokens": "Jetons d'entrée",
            "outputTokens": "Jetons de sortie",
            "cacheCreationTokens": "Jetons d'écriture du cache",
            "cacheReadTokens": "Jetons de lecture du cache",
            "tokenBreakdown": "Répartition des jetons",
            "fundingBreakdown": "Répartition du financement",
            "yourConnection": "Votre connexion",
            "estimateDisclaimer": "Le nombre de jetons est exact. Les montants en dollars sont des estimations et peuvent différer de la facturation réelle.",
            "vinceAi": "IA Vince",
            "estimateHint": "Total cumulé pour cette session de construction. Le montant en dollars est une estimation.",
            "tokensValue": "{value} jetons",
            "estimateSuffix": "(est.)",
            "noUsageRecorded": "Aucune utilisation enregistrée pour cette session.",
            "vinceProvided": "Fourni par Vince",
            "unknownConnection": "Connexion inconnue",
            "byConnection": "Par connexion",
            "sessionsCount": "{count} sessions",
            "unpricedUsage": "Une partie de l'utilisation n'a pas pu être tarifée",
            "permissionDenied": "Vous n'êtes pas autorisé à consulter cette utilisation.",
            "loadError": "Impossible de charger l'utilisation. Veuillez réessayer."
        }
    },
    "foundation": {
        "resource": {
            "apiclient": "Client API",
            "connection": "Connexion",
            "dashboard": "Tableau de bord",
            "environment": "Environnement",
            "user": "Utilisateur",
            "workflow": "Flux de travail",
            "group": "Groupe",
            "variable": "Variable",
            "webhook": "Webhook",
            "metadata": "Métadonnées",
            "gateway": "Passerelle"
        }
    },
    "core": {
        "app": {
            "ai-apps": "Applications d'IA",
            "customtables": "Tables personnalisées",
            "fnd": "Fondation",
            "tenantManagement": "Gestion des locataires"
        }
    },
    "addon": {
        "app": {
            "kanban": "Kanban",
            "campaign": "Campagne",
            "impexHelper": "Assistant Impex",
            "mdbreadmiHelper": "Assistant MDB Readmi",
            "miTest": "Test MI",
            "m3PrintoutConfig": "Configuration des impressions M3",
            "vincePricer": "Vince Pricer",
            "cugexHelper": "Assistant CUGEX",
            "isLantmannen": "Est Lantmannen",
            "spykar": "Spykar",
            "eshopbox": "Eshopbox",
            "scannerPickPack": "Scanner Pick Pack",
            "pickPack": "Pick Pack",
            "contractManagement": "Gestion des contrats",
            "aiApps": "Applications d'IA"
        }
    },
    "fileSelector": {
        "microsoftThrottled": "Microsoft a temporairement limité les requêtes SharePoint. Patientez un instant, puis réessayez.",
        "sitesLoadFailed": "Impossible de charger les sites SharePoint.",
        "itemsLoadFailed": "Impossible de charger les fichiers SharePoint.",
        "retry": "Réessayer"
    },
    "wildcard": {
        "option": "Tous",
        "fullAccess": "Accès complet"
    },
    "action": {
        "read": "Lire",
        "write": "Écrire"
    },
    "customTable": {
        "resource": {
            "configuration": "Configuration",
            "data": "Données"
        }
    },
    "common": {
        "logicalOperators": {
            "AND": "ET",
            "OR": "OU"
        },
        "actions": {
            "advanced": "Paramètres avancés",
            "apply": "Appliquer",
            "back": "Retour",
            "cancel": "Annuler",
            "clear": "Effacer",
            "close": "Fermer",
            "copy": "Copier",
            "yesDelete": "Oui, supprimer",
            "create": "Créer",
            "delete": "Supprimer",
            "edit": "Modifier",
            "next": "Suivant",
            "no": "Non",
            "ok": "OK",
            "previous": "Précédent",
            "reset": "Réinitialiser",
            "save": "Enregistrer",
            "update": "Mettre à jour",
            "view": "Voir",
            "yes": "Oui",
            "activate": "Activer",
            "deactivate": "Désactiver",
            "goHomePage": "Retourner à la page d'accueil",
            "add": "Ajouter",
            "execute": "Exécuter",
			"selectAll": "Tout sélectionner",
			"showSelected": "Afficher la sélection"
        },
        "system": "Système",
        "label": "Étiquette",
        "labels": "Étiquettes",
        "actionsLabel": "Actions",
        "noPermission": "Vous n'avez pas la permission d'effectuer cette action.",
        "active": "Actif",
        "activated": "Activé",
        "deactivated": "Désactivé",
        "address": "Adresse",
        "alias": "Alias",
        "confirmation": "Confirmation",
        "description": "Description",
        "details": "Détails",
        "download": "Télécharger",
        "email": "Email",
        "tenantPermissions": "Autorisations du locataire",
        "firstName": "Prénom",
        "surname": "Nom de famille",
        "fullName": "Nom complet",
        "in": "dans",
        "lastName": "Nom de famille",
        "left": "Gauche",
        "loading": "Chargement",
        "milliseconds": "ms",
        "name": "Nom",
        "notFound": "Non trouvé",
        "notFoundAbbreviation": "NF",
        "of": "de",
        "operation": {
            "EqualTo": "Égal à",
            "GreaterThan": "Supérieur à",
            "GreaterThanEqualTo": "Supérieur ou égal à",
            "LessThan": "Inférieur à",
            "LessThanEqualTo": "Inférieur ou égal à",
            "NotEqualTo": "Différent de"
        },
        "password": "Mot de passe",
        "permissions": "Autorisations",
        "phone": "Téléphone",
        "primary": "PRIMAIRE",
        "right": "Droite",
        "roles": "Rôles",
        "noRoles": "Aucun rôle attribué",
        "search": "Recherche",
        "searchPlaceholder": "Tapez pour rechercher",
        "texts": {
            "item": "item",
            "selected": "choisie",
            "select": "Sélectionner"
        },
        "tags": "Tags",
        "success": "Succès",
        "assignRolesToUser": "Ajouter cet utilisateur aux rôles",
        "assignTagsToUser": "Attribuer des tags à cet utilisateur"
    },
    "comparison": {
        "equal": "Égal (=)",
        "greaterThan": "Supérieur (>)",
        "greaterThanInclusive": "Supérieur ou égal (>=)",
        "isBlank": "Est vide (=)",
        "isNotBlank": "N'est pas vide (!=)",
        "lessThan": "Inférieur (<)",
        "lessThanInclusive": "Inférieur ou égal (<=)",
        "notEqual": "Différent (!=)",
        "stringContains": "Contient la chaîne",
        "stringNotContains": "Ne contient pas la chaîne"
    },
    "dataTypes": {
        "DATE": "Date",
        "NUMERIC": "Nombre",
        "STRING": "Texte",
        "BOOLEAN": "Booléen"
    },
    "environments": {
        "code": "ID d'environnement dans VXL Live",
        "deleteConfirmation": "Voulez-vous supprimer {environmentName} ?",
        "descriptionRequired": "La description de l'environnement est requise",
        "environmentActions": {
            "deleteEnvironment": {
                "title": "Confirmer la suppression"
            }
        },
        "idRequired": "L'ID d'environnement est requis",
        "messages": {
            "deleteSuccess": "Environnement supprimé avec succès!",
            "cannotDeleteEnvironmentInConnection": "Impossible de supprimer, l'environnement existe dans une connexion",
            "codeFormat": "Le code accepte 1 à 4 lettres (A-Z). Exemple : TEST, PROD",
            "environmentNameExists": "L'environnement {environmentName} existe déjà !",
            "errorOccurred": "Une erreur est survenue",
            "success": "Environnement enregistré avec succès !"
        },
        "nameRequired": "Le nom de l'environnement est requis",
        "newEnvironment": "Nouvel environnement",
        "selectColor": "Sélectionner une couleur",
        "theme": "Thème",
        "title": "Environnements"
    },
    "connections": {
        "port": "Port",
		"m3Name": "Nom M3",
		"clientId": "Identifiant client",
		"clientSecret": "Secret client",
		"autofillDetails": "Remplissage automatique à partir d'un fichier",
		"uploadFile": "Téléverser un fichier",
        "authenticationType": "Type d'authentification",
        "accessKey": "Clé d'accès",
        "authHeaderName": "Nom de l'en-tête d'autorisation",
        "messages": {
            "confirmDeleteHeader": "Supprimer la connexion",
            "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer cette connexion ?",
            "confirmCertificateIssueHeader": "Émettre un certificat",
            "confirmCertificateIssueMessage": "Êtes-vous sûr de vouloir émettre un certificat pour cette connexion ?",
            "confirmCertificateRevokeHeader": "Révoquer le certificat",
            "confirmCertificateRevokeMessage": "Êtes-vous sûr de vouloir révoquer le certificat pour cette connexion ?",
            "saveSuccess": "Connexion enregistrée avec succès",
            "deleteSuccess": "Connexion supprimée avec succès",
            "validateSuccess": "Connexion validée avec succès",
            "certificate": "Certificat",
            "certificateIssueSuccess": "Certificat délivré avec succès",
            "mandatoryField": "Ce champ est obligatoire",
            "cannotDelete": "Cette connexion ne peut pas être supprimée car elle est liée à un ou plusieurs workflows",
            "importApiErrorMessage": "Impossible d'importer les API.",
            "bulkImportApiError": "Impossible de démarrer l'importation groupée des API.",
            "loadApiProgramsError": "Impossible de charger les programmes API pour cette connexion.",
            "loadConnectionForImportError": "Impossible de charger la connexion sélectionnée.",
            "errorWithReason": "{message} Raison : {reason}",
            "environmentAlreadyConnectedError": "Une connexion de type {system} existe déjà dans l'environnement {environment}!",
            "certificateIgnoredMessage": "«Utiliser un proxy» est activé, le certificat sera ignoré."
        },
        "certificate": {
			"title": "Certificat MTLS",
			"VinceLiveCertificate": "Utiliser le certificat Vince Live",
			"CustomCertificate": "Utiliser un certificat personnalisé",
			"label": "Certificat",
			"privateKey": "Clé privée",
			"VLCertificatePlaceholder": "Certificat de Vince Live",
			"CustomCertificatePlaceholder": "Saisir le certificat ou télécharger le fichier ci-dessous",
			"CustomPrivateKeyPlaceholder": "Saisir la clé privée ou télécharger le fichier ci-dessous",
			"fileWarningMessage": "Le fichier doit être au format OpenSSL",
			"changePrivateKey": "Modifier le fichier de clé privée",
			"changeCertificate": "Modifier le fichier de certificat",
			"privateKeyLoaded": "✓ Clé privée chargée ({length} caractères)",
			"certificateLoaded": "✓ Certificat chargé ({length} caractères)"
		},
        "connectivity": "Connectivité",
        "security": "Sécurité",
        "details": "Détails"
    },
    "header": {
        "apiClients": "Clients API",
        "roles": "Rôles",
        "users": "Utilisateurs",
        "tenants": "Locataires"
    },
    "notifications": {
		"noNotifications": "Pas de nouvelles notifications",
		"announcement": "Annonce",
		"title": "Notifications",
        "clearAll": "Tout effacer",
        "workflowSuccessful": "Exécution du workflow réussie",
        "workflowFailed": "Échec du workflow",
		"acknowledge": "Accuser réception de la notification",
		"customTables": {
			"header": "Erreur d'indexation de table",
			"indexError": "L'indexation a échoué pour la table \"{tableName}\"",
			"toastSummary": "Erreur d'indexation de table",
			"toastDetailWithReason": "Table: \"{tableName}\"\nClé(s): {keys}\n\nRaison : {reason}",
			"toastDetail": "Table: \"{tableName}\"\nClé(s): {keys}\n\nL'indexation a échoué",
			"viewTable": "Voir la table",
			"unknownError": "Erreur inconnue"
		}
	},
    "home": {
        "greeting": {
            "morning": "Bonjour",
            "afternoon": "Bon après-midi",
            "evening": "Bonsoir"
        },
        "tenantLabel": "Locataire :",
        "welcomeMessage": "Bienvenue sur la plateforme Vince.\nCréez, automatisez et gérez votre travail en un seul endroit — de la création d'applications et de workflows à la structuration des données dans des tableaux et à la gestion administrative en toute confiance. Love from Vince Team 🧡\nSi la vieille version vous manque, vous pouvez y accéder pour une durée limitée en utilisant https://{tenantAlias}.old.vince.live",
        "logoAlt": "Logo Vince",
        "cards": {
            "feedback": {
                "title": "Donnez-nous votre avis",
                "content": "Nous voulons avoir votre avis !\nVos retours façonnent l’avenir de Vince. Vous avez trouvé un bug ? Une excellente idée ? Vous voulez nous dire ce qui marche ou non ? Faites-le nous savoir !",
                "buttonLabel": "Donnez-nous votre avis"
            },
            "documentation": {
                "title": "Documentation",
                "content": "Tout ce dont vous avez besoin — à un seul endroit.\nQue vous soyez nouveau chez Vince ou un utilisateur expérimenté, notre documentation est là pour vous aider. Parcourez les guides, les conseils de configuration, et bien plus encore.\n\nPlongez dans la base de connaissances.",
                "buttonLabel": "Documentation"
            },
            "releaseNotes": {
                "title": "Notes de version",
                "content": "Restez informé des dernières fonctionnalités, améliorations et corrections. Nos notes de version sont claires et concises – pour que vous passiez moins de temps à lire et plus de temps à créer.\nNous publions régulièrement de nouvelles fonctionnalités, des améliorations et des correctifs.\n\nConsultez le journal complet des modifications.",
                "buttonLabel": "Voir les notes de version"
            },
            "news": {
                "title": "Actualités de Vince",
                "content": "Que se passe-t-il chez Vince ?\nRestez informé avec les annonces produits, des coulisses et des conseils de notre équipe. Nous construisons en toute transparence — et vous êtes invité.\n\nDécouvrez les derniers temps forts.",
                "buttonLabel": "Visitez Vince"
            }
        }
    },
    "menus": {
        "administration": "Administration",
        "home": "Accueil",
        "info": "Infos",
        "apps": "Applications",
        "settings": "Paramètres",
        "accessManagement": "Gestion des accès",
        "reports": "Rapports",
		"aiSettings": "Paramètres IA",
		"workflowSettings": "Paramètres de flux de travail",
		"workflowManagement": "Gestion des flux de travail",
		"external": "Aide et ressources",
		"integrations": "Intégrations",
        "subMenus": {
            "users": "Utilisateurs",
			"roles": "Rôles",
			"apiClients": "Clients API",
            "tenants": "Locataires",
            "accessManagement": "Gestion des accès",
            "auditLog": "Journal d'audit",
            "environments": "Environnements",
            "companySettings": "Paramètres de l'entreprise",
            "connections": "Connexions",
            "documentation": "Documentation",
            "groups": "Groupes",
            "latestUpdates": "Dernières mises à jour",
            "logOut": "Se déconnecter",
            "schedules": "Horaires",
            "support": "Support",
            "tableManagement": "Gestion des tables",
            "userProfile": "Mon profil",
            "variables": "Variables",
            "webhooks": "Webhooks",
            "workflowStatistics": "Statistiques de flux de travail",
            "addConnection": "Ajouter une connexion",
            "editConnection": "Modifier la connexion",
			"newConnection": "Nouvelle connexion",
			"manageEnvironments": "Gérer les environnements",
            "apps": {
                "clickAndCollect": "Click and Collect",
                "campaign": "Campagne",
                "impexHelper": "Assistant Impex",
                "mdbreadHelper": "Assistant MDBread",
                "miTest": "Test MI",
                "m3PrintoutConfig": "Configuration d'impression M3",
                "vincePricer": "Évaluateur Vince",
                "cugexHelper": "Assistant CUGEX",
                "lantmannenMaskin": "Lantmannen Maskin",
                "spykarChannelPlan": "Plan de canal Spykar",
                "eshopbox": "Eshopbox",
                "scannerPickPack": "Scanner Prélèvement et Emballage",
                "pickPack": "Prélèvement et Emballage",
                "contractManagement": "Gestion des contrats"
            }
        },
        "workflows": "Flux de travail"
    },
    "profile": {
        "dateFormat": "Format de date",
        "defaultDashboard": "Tableau de bord par défaut",
        "languagePreference": "Préférence de langue",
        "messages": {
            "error": "Impossible d'enregistrer les préférences !",
            "success": "Préférences enregistrées avec succès !",
            "nameUpdatedSuccess": "Nom mis à jour avec succès !"
        },
        "numberPerPage": "Nombre d'enregistrements dans les tables",
        "preferences": "Préférences",
        "timeFormat": "Format de l'heure",
        "userProfile": "Paramètres du profil",
        "cookieConsent": {
            "title": "Consentement aux cookies",
            "necessary": "Nécessaires",
            "statistics": "Statistiques",
            "description1": "Certains de nos cookies sont essentiels au fonctionnement de l'application et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement définis en réponse à des actions que vous effectuez, telles que la connexion, le remplissage de formulaires ou la définition de vos préférences de confidentialité.",
            "description2": "Afin de créer des solutions pour une application aussi conviviale que possible, nous utilisons l'outil d'analyse Posthog. Avec l'aide de Posthog, nous pouvons collecter des données et analyser comment les applications et services Vince sont utilisés.",
            "infoTitle": "Quelles informations sont stockées ?",
            "description3": "Posthog reçoit des statistiques générales sur le web et les applications. Aucune de ces informations ne peut être utilisée pour identifier les utilisateurs. Vince utilise uniquement des cookies à des fins analytiques pour développer nos produits afin de mieux répondre aux besoins de nos utilisateurs, et non à des fins marketing."
        },
        "privacyPolicy": {
            "title": "Politique de confidentialité",
            "customerPortal": "Portail client",
            "sections": [
                {
                "title": "1. Qui sommes-nous",
                "content": "La présente Politique de confidentialité s'applique à la plateforme Vince Live (\"Vince Live\") ainsi qu'au complément VXL Live Excel (le \"Complément\") pour Microsoft 365 (ensemble, le \"Service\").\nLe Service est exploité par Vince AS (n° d'organisation 896 890 042), une société enregistrée en Norvège dont le siège est situé Riddervolds gate 4, 0256 Oslo, Norvège.\nNotre site web est {website}.\nNous agissons en tant que responsable du traitement pour les données personnelles liées aux comptes et au service, et en tant que sous-traitant pour les données personnelles traitées par les organisations clientes via les workflows de notre plateforme.\nPour toute question ou demande relative à la protection des données, veuillez nous contacter via notre {customerPortal} ou par e-mail à {email}. Le cas échéant, vous pouvez également contacter notre délégué à la protection des données (DPO) via ce même portail."
                },
                {
                "title": "2. Rôles dans le traitement",
                "content": "Lorsque nous fournissons les services, nous agissons en tant que responsable du traitement pour les données de compte, d'authentification, de journalisation et d'analyse.\nPour les données des workflows, nous agissons en tant que sous-traitant et traitons les données personnelles uniquement selon les instructions des organisations clientes, qui sont responsables de fournir les informations requises et de disposer d'une base juridique.\nLe traitement des données personnelles pour le compte des organisations clientes est régi par nos Conditions générales et notre Accord de traitement des données (DPA). La présente Politique de confidentialité s'applique uniquement aux traitements pour lesquels nous agissons en tant que responsable du traitement."
                },
                {
                "title": "3. Catégories de données personnelles que nous traitons (en tant que responsable du traitement)",
                "content": "Nous traitons les catégories de données personnelles suivantes :",
                "items": [
                    "Données de compte : nom, adresse e-mail, appartenance à une organisation et rôle",
                    "Données d'authentification : identifiants, jetons et méthodes MFA",
                    "Données d'identité provenant de Microsoft Entra ID : identifiants uniques et données de profil reçues lorsque vous vous connectez avec votre compte professionnel ou scolaire Microsoft",
                    "Données techniques : adresse IP, informations sur l'appareil ou le navigateur et identifiants de session",
                    "Journaux de service : journaux système, journaux d'erreurs et journaux d'audit/d'activité (également visibles par les administrateurs des clients)",
                    "Données de communication : coordonnées utilisées pour les communications opérationnelles",
                    "Données analytiques (optionnelles) : statistiques d'utilisation et rapports d'erreurs"
                ],
                "footer": "Les données de facturation sont traitées séparément dans le cadre du contrat et non via la plateforme.\nNous ne vendons ni ne louons les données personnelles. Elles sont partagées uniquement avec les sous-traitants décrits dans cette politique ou lorsque la loi l'exige."
                },
                {
                "title": "4. Finalités et base juridique (en tant que responsable du traitement)",
                "content": "Nous traitons les données personnelles uniquement lorsqu'une base juridique existe conformément au RGPD :",
                "items": [
                    "Exécution du contrat - gestion des comptes utilisateurs, authentification des utilisateurs, exploitation des Services et conservation des journaux d'activité nécessaires",
                    "Intérêts légitimes - surveillance des services, communications opérationnelles et sécurité",
                    "Consentement - analyses (optionnelles ; pour analyser les performances et l'utilisation du service, à l'exclusion des Données Client)",
                    "Obligations légales - respect des exigences légales"
                ]
                },
                {
                "title": "5. Données des workflows (rôle de sous-traitant)",
                "content": "Les organisations clientes peuvent configurer des workflows contenant des données personnelles. Dans ces cas, le client est responsable du traitement et nous agissons uniquement en tant que sous-traitant. Nous traitons les données des workflows uniquement dans la mesure nécessaire pour fournir, sécuriser ou assister les services."
                },
                {
                "title": "6. Sous-traitants",
                "content": "Nous utilisons des sous-traitants conformes au RGPD, tous hébergés dans l'UE/l'EEE :",
                "items": [
                    "Amazon Web Services (AWS) - hébergement et infrastructure",
                    "Twilio / SendGrid - envoi de SMS et d'e-mails",
                    "PostHog - analyses (optionnelles)",
                    "Sentry - suivi des erreurs"
                ]
                },
                {
                "title": "7. Droits des personnes concernées (en tant que responsable du traitement)",
                "content": "Vous disposez des droits prévus aux articles 15 à 22 du RGPD, notamment le droit d'accès, de rectification, d'effacement, de limitation, de portabilité, d'opposition et de retrait du consentement.\nVous avez également le droit d'introduire une réclamation auprès de l'Autorité norvégienne de protection des données (Datatilsynet) conformément à l'article 77 du RGPD. Les informations de contact de Datatilsynet sont disponibles sur {datatilsynet}.\nDes outils en libre-service sont disponibles sur la plateforme, ou vous pouvez soumettre une demande via notre {customerPortal} ou par e-mail à {email}. Pour les données des workflows où nous agissons en tant que sous-traitant, les demandes doivent être adressées à l'organisation cliente concernée."
                },
                {
                "title": "8. Conservation et suppression",
                "content": "Les données personnelles sont conservées uniquement pendant la durée nécessaire à la fourniture du service. Les journaux et données d'activité sont conservés jusqu'à 90 jours. Après la fermeture d'un compte, les données personnelles sont supprimées dans un délai de 90 jours, sauf si une durée de conservation plus longue est requise par la loi."
                },
                {
                "title": "9. Sécurité",
                "content": "Nous appliquons des mesures techniques et organisationnelles telles que le chiffrement des données au repos et en transit, des contrôles d'accès stricts et un hébergement sécurisé dans l'UE/l'EEE."
                },
                {
                "title": "10. Transferts internationaux",
                "content": "L'ensemble de l'hébergement et du sous-traitement est effectué au sein de l'UE/l'EEE. Aucun transfert international de données personnelles n'a lieu."
                },
                {
                "title": "11. Modifications",
                "content": "Nous pouvons mettre à jour cette politique de temps à autre. Les modifications importantes seront communiquées via la plateforme ou par e-mail."
                },
                {
                "title": "12. Complément VXL Live Excel",
                "content": "Cette section décrit la manière dont les données personnelles sont traitées lorsque vous utilisez le complément VXL Live Excel pour Microsoft 365 (le \"Complément\").",
                "items": [
                    "Le Complément dispose uniquement des autorisations nécessaires pour lire et écrire dans le classeur actuel. Il n'accède pas aux autres fichiers, boîtes mail ou services.",
                    "Les données du classeur envoyées à Vince Live dans le cadre d'un workflow (y compris des données personnelles) sont traitées comme des Données de workflow conformément à la section 5.",
                    "Le Complément n'utilise pas le contenu du classeur à des fins publicitaires ou de profilage et ne vend ni ne loue de données personnelles."
                ]
                },
                {
                "title": "13. Contact",
                "content": "Vince AS\nN° d'organisation 896 890 042\nRiddervolds gate 4, 0256 Oslo, Norvège\n{website}\n{customerPortal}\nDernière mise à jour : novembre 2025"
                }
            ]
        },
        "tableAndDataFormatting": "Mise en forme des tableaux et des données"
    },
    "security": {
        "accessManagement": "Gestion des accès",
        "forbidden": "Interdit",
        "youDontHavePermission": "Désolé, vous n'avez pas les autorisations nécessaires pour accéder à cette ressource. Contactez votre administrateur locataire concernant vos autorisations.",
        "apiClients": {
            "activateApiClients": "Voulez-vous activer le client API ?",
            "active": "Actif",
            "addApiClients": "Ajouter des clients API",
            "apiClient": "Client API",
            "apiClientName": "Nom du client API",
            "createApiClients": "Créer des clients API",
            "deactivateApiClients": "Voulez-vous désactiver le client API ?",
            "description": "Description",
            "loadingApiClients": "Chargement des clients API...",
            "name": "Nom",
            "updatingApiClientsRoles": "Mise à jour des rôles du client API..."
        },
        "roles": {
            "header": "Rôles",
            "addRole": "Ajouter un rôle",
            "roleName": "Nom du rôle",
            "placeholder": "Sélectionner des rôles",
            "newRole": "Nouveau rôle",
            "inactive": "Inactif",
            "active": "Actif",
            "numberOfUsers": "Nombre d'utilisateurs",
            "numberOfPermissions": "Nombre d'autorisations",
            "externalId": "ID externe",
            "externalIdPlaceholder": "ID de groupe IdP (par ex. ID d'objet de groupe Microsoft Entra)",
            "externalIdHint": "Associez ce rôle à un groupe du fournisseur d'identité pour le provisionnement SCIM.",
            "table": {
                "app": "Application",
                "resource": "Ressource",
                "resourceName": "Nom de la ressource",
                "addPermissions": "Ajouter des autorisations",
                "selectApp": "Sélectionner une application",
                "selectResource": "Sélectionner une ressource",
                "selectResourceName": "Sélectionner le nom de la ressource",
                "selectPermission": "Sélectionner une autorisation",
                "permission": "Autorisation",
                "resourceNameNotAvailable": "Le nom de cette ressource n'était pas accessible."
            },
            "messages": {
                "nameRequired": "Le nom du rôle est requis.",
                "descriptionRequired": "La description est requise.",
                "appRequired": "L'application est requise.",
                "resourceRequired": "La ressource est requise.",
                "resourceNameRequired": "Le nom de la ressource est requis.",
                "actionRequired": "L'action est requise.",
                "success": "Rôle enregistré avec succès.",
                "deleteRoleConfirmation": "Êtes-vous sûr de vouloir supprimer le rôle {roleName} ?",
                "deleteRoleSuccess": "Rôle supprimé avec succès.",
                "activateSuccess": "Rôle activé avec succès !",
                "deactivateSuccess": "Rôle désactivé avec succès !"
            }
        },
        "users": {
            "addUser": "Ajouter un utilisateur",
            "lastActive": "Dernière activité",
            "manageUser": "Gérer l'utilisateur",
            "deactivateUser": "Désactiver l'utilisateur",
            "deactivateUserConfirm": "Voulez-vous désactiver cet utilisateur ?",
			"deactivateSuccessMessage": "L'utilisateur a été désactivé avec succès",
			"activateUser": "Activer l'utilisateur",
			"activateUserConfirm": "Voulez-vous activer cet utilisateur ?",
			"activateSuccessMessage": "L'utilisateur a été activé avec succès",
			"resendInvite": "Renvoyer l'invitation",
			"resendInviteSuccessMessage": "L'invitation a été envoyée à l'utilisateur avec succès",
            "permissions": {
                "VINCE_LIVE_ADMIN": "Administrateur Live",
                "VINCE_LIVE_USER": "Utilisateur Live",
                "TENANT_ADMIN": "Administrateur",
                "TENANT_USER": "Utilisateur"
            },
            "activeUsers": "{used}/{total} utilisateurs actifs sur votre plan locataire.",
            "abovePlan": "Vous dépassez votre forfait, des coûts seront ajoutés par utilisateur.",
            "upgradePlanLink": "Mettez à niveau votre forfait"
        }
    },
    "signIn": {
        "backToSignIn": "Retour à la connexion",
        "forgotPassword": "Mot de passe oublié ?",
        "forgotPasswordInstruction": "Vous recevrez un mail et un code pour réinitialiser votre mot de passe.",
        "invalidPassword": "! Mot de passe incorrect",
        "login": "Se connecter",
        "loginMicrosoft": "Se connecter avec Microsoft",
        "loginOkta": "Se connecter avec Okta",
        "preparingVince": "Préparation de votre expérience Vince...",
        "resetPassword": "Réinitialiser le mot de passe",
        "signinTo": "Se connecter à {tenant}",
        "userNotFound": "! Oups, e-mail non trouvé. Veuillez saisir un e-mail enregistré ou contacter le support",
        "confirmationCodeRequired": "Code de confirmation requis",
		"passwordCriteriaMismatch": "! Le mot de passe ne correspond pas aux critères",
		"invalidConfirmationCode": "Code de vérification non valide, veuillez réessayer.",
		"attemptLimitExceeded": "Nombre de tentatives dépassé, veuillez réessayer ultérieurement.",
		"confirmationCode": "Code de confirmation",
		"confirmationCodeInstruction": "Le code de confirmation a été envoyé à votre adresse e-mail.",
		"newPassword": "Nouveau mot de passe",
		"newPasswordInstruction": "* Le mot de passe doit comporter au moins 8 caractères, dont une majuscule, une minuscule et un chiffre",
        "invalidParameter": "Erreur lors de la réinitialisation du mot de passe, contactez le support pour obtenir de l'aide.",
        "enterValidEmail": "S'il vous plaît, mettez une adresse email valide.",
        "userDisabled": "L'utilisateur est désactivé, veuillez contacter le support",
        "selectSsoProvider": "Sélectionner un fournisseur SSO",
        "processingSso": "Traitement de la connexion SSO....",
        "ssoAuthFailed": "Échec de l'authentification. Veuillez réessayer.",
        "externalAuthRedirecting": "Redirection...",
        "externalAuthCompleted": "Authentification terminée. Vous pouvez fermer cette fenêtre.",
        "externalAuthFailed": "Échec de l'authentification. Vous pouvez fermer cette fenêtre et réessayer."
    },
    "tables": {
        "chooseExcelFile": "Sélectionner un fichier",
        "columns": "Colonnes",
        "copy": "Copier la table",
        "copyPrefix": "Copie de ",
        "createdBy": "Créé par",
        "emptyFilteredText": "Aucun enregistrement ne correspond à votre demande.",
        "noEntitiesMessage": "Aucune entité dans cet espace de travail du locataire.",
        "createTable": "Créer une table",
        "delete": "Supprimer la table",
        "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer la table {tableName} ? \nLe processus de suppression peut prendre jusqu'à 6 heures. \nPendant ce temps, la table restera dans le statut \n\"Suppression en cours...\"",
        "deleteData": "Supprimer le contenu",
        "deleteItem": "Supprimer la table",
        "deletingInProgress": "Suppression en cours...",
        "deleteTableSuccess": "Table supprimée avec succès",
        "dragExcelFiles": "Glissez-déposez les fichiers Excel ici pour les télécharger.",
        "edit": "Modifier la table",
        "validateConnection": "Valider la connexion",
		"importAPIs": "Importer des API",
		"issueMTLSCert": "Délivrer un certificat MTLS",
		"editConnection": "Modifier",
		"deleteConnection": "Supprimer",
        "form": {
            "addColumnButton": "Ajouter une colonne",
            "columnAliasNameField": "Nom d'alias",
            "columnNameField": "Nom de colonne",
            "dataTypeField": "Type de données",
            "linkField": "Lien",
            "linkTextField": "Texte du lien",
            "primaryKeyField": "Clé primaire",
            "validations": {
                "duplicateColumnNamesError": "Noms de colonnes en double trouvés : {duplicates}.",
                "emptyColumnNameError": "Le nom de colonne ne peut pas être vide."
            }
        },
        "modifiedBy": "Modifié par",
        "new": "Créer une nouvelle table",
        "rows": "Lignes",
        "showColumnConfig": "Informations sur les colonnes",
        "showData": "Afficher les données",
        "tableConfig": "Configuration de la table",
        "tableName": "Nom de la table",
        "title": "Gestion des tables",
        "truncateConfirmation": "Êtes-vous sûr de vouloir supprimer toutes les lignes de la table {tableName} ?",
        "truncateItem": "Vider la table",
        "truncateTableSuccess": "Données de la table supprimées avec succès",
        "updateType": "Type de mise à jour",
        "updateTypes": {
            "APPEND": "Ajouter",
            "REPLACE": "Remplacer",
            "UPSERT": "Mettre à jour ou insérer"
        },
        "upload": "Télécharger Excel",
        "uploadExcel": "Télécharger Excel",
        "deleteRowMessage": "Êtes-vous sûr de vouloir supprimer les lignes sélectionnées?",
		"deleteRowSuccess": "Les lignes sélectionnées ont été supprimées. Les modifications peuvent mettre un certain temps à apparaître.",
		"deleteRowButtonLabel": "Supprimer ({selectedRows} lignes)",
        "saveSuccess": "La configuration du tableau a été enregistrée avec succès."
    },
    "tags": {
        "addTag": "Ajouter une étiquette",
        "duplicateKey": "Une étiquette avec cette clé existe déjà",
        "editTag": "Modifier l'étiquette",
        "createTag": "Créer une étiquette",
        "placeholder": "Les tags sont des paires clé-valeur que l'utilisateur peut associer à des entités pour filtrer les données et contrôler l'accès sur la plateforme Vince.",
		"noTagsApplied": "Aucun tag n'a été appliqué pour cet utilisateur",
        "confirmRemoveTag": "Êtes-vous sûr de vouloir supprimer cette étiquette ?",
		"tagName": "Nom de l'étiquette",
		"tagValue": "Valeur/Clé",
        "nameOfTag": "Nom de l'étiquette",
		"valueKey": "Clé de valeur"
    },
    "users": {
        "addRoles": "Ajouter des rôles",
        "addUser": "Ajouter un utilisateur",
        "newUser": "Nouvel utilisateur",
        "edit": "Modifier",
        "personalInfo": "Informations personnelles",
        "saveSuccess": "Utilisateur enregistré avec succès",
        "saveError": "Erreur lors de l'enregistrement de l'utilisateur",
        "userNotFound": "Utilisateur non trouvé",
        "loadError": "Erreur lors du chargement des données utilisateur",
        "selectRole": "Sélectionner un rôle",
        "assignRolesToUser": "Ajouter cet utilisateur aux rôles",
        "assignTagsToUser": "Attribuer des tags à cet utilisateur",
        "userFields": {
            "lastActive": "Dernière activité",
            "m3userId": "ID utilisateur M3"
        },
        "validation": {
            "keyRequired": "La clé est requise",
            "duplicateTagKey": "La clé de tag \"{value}\" existe déjà",
            "valueEmpty": "La valeur ne peut pas être vide",
            "valueRequired": "Au moins une valeur est requise",
            "singleValueAllowed": "Une seule valeur est autorisée",
            "firstNameRequired": "Le prénom est requis",
            "firstNameMinLength": "Le prénom doit comporter au moins 2 caractères",
            "firstNameMaxLength": "Le prénom ne doit pas dépasser 50 caractères",
            "lastNameRequired": "Le nom de famille est requis",
            "lastNameMinLength": "Le nom de famille doit comporter au moins 2 caractères",
            "emailRequired": "L'email est requis",
            "emailInvalid": "Veuillez entrer un email valide",
            "emailInUse": "Cet email est déjà utilisé",
            "permissionRequired": "La permission est requise"
        }
    },
    "roles": {
        "addRole": "Ajouter un rôle",
		"createRole": "Créer un rôle",
        "placeholder": "Les rôles permettent d'attribuer des autorisations pour afficher ou modifier des tableaux de bord, des flux de travail ou des tableaux",
		"noRolesApplied": "Aucun rôle n'a été attribué à cet utilisateur.",
        "confirmRemoveRole": "Êtes-vous sûr de vouloir supprimer le rôle « {roleName} » de cet utilisateur ?"
    },
    "apiClients": {
        "apiClientName": "Nom du client API",
        "description": "Description",
        "active": "Actif",
        "action":"Action",
        "addApiClient": "Ajouter un client API",
        "messages": {
            "deleteAPIClientConfirmation": "Êtes-vous sûr de vouloir supprimer le client API '{apiClientName}'?",
            "deleteAPIClientSuccess": "Client API supprimé avec succès.",
            "deactivateAPIClientConfirmation": "Souhaitez-vous désactiver le client API '{apiClientName}'?",
            "apiClientNameRequired": "Nom du client requis",
            "success": "Client API enregistré avec succès!",
            "activateSuccess": "Client API activé avec succès!",
			"deactivateSuccess": "Client API désactivé avec succès!",
			"apiClientNameInvalid": "Le nom ne peut contenir que des caractères alphanumériques, des espaces et les éléments suivants: +=,.@-"
        },
        "name":"Nom",
        "label":"Libellé",
        "roles":"Rôles",
        "clientId": "ID client API",
        "clientSecret": "Secret du client API",
        "newAPIClient": "Nouveau client API",
        "editAPIClient": "Modifier le client API"
    },
    "webhooks": {
        "activateSuccess": "Webhook activé avec succès!",
        "deactivateSuccess": "Webhook désactivé avec succès!",
        "description": "Description",
        "invalidWorkflow": "Flux de travail invalide",
        "messages": {
            "copied": "Copié dans le presse-papiers",
            "copyError": "Échec de la copie",
            "deleteWebhookConfirmation": "Êtes-vous sûr de vouloir supprimer le webhook {webhookName}?",
            "deleteWebhookSuccess": "Webhook supprimé avec succès!",
            "success": "Webhook enregistré avec succès!",
            "webhookNameRequired": "Le nom du webhook est requis",
            "workflowRequired": "Le flux de travail est requis"
        },
        "newWebhook": "Nouveau Webhook",
        "title": "Webhooks",
        "webhookDetails": "Détails du Webhook",
        "webhookId": "ID du Webhook",
        "webhookName": "Nom du Webhook",
        "workflow": "Flux de travail",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "token": "Jeton"
    },
    "variables": {
        "addVariable": "Ajouter une variable",
        "deleteConfirmation": "Voulez-vous supprimer {variableName} ?",
        "descriptionRequired": "La description de la variable est requise",
        "idRequired": "L'ID de la variable est requis",
        "tooltip": "Les variables sont des valeurs qui peuvent être utilisées dans les flux de travail pour rendre les configurations plus dynamiques.",
        "messages": {
            "success": "Variable enregistrée avec succès !",
            "deleteVariableConfirmation": "Voulez-vous supprimer la variable {variableName} ?",
            "variableNameRequired": "Le nom de la variable est requis",
            "variableValueRequired": "La valeur de la variable est requise",
            "deleteSuccess": "Variable supprimée avec succès!"
        },
        "name": "Nom",
        "newVariable": "Nouvelle variable",
        "title": "Variables",
        "value": "Valeur",
        "secure": "Sécurisé",
        "unsecure": "Non sécurisé"
    },
    "company": {
        "headers": {
            "settings": "Paramètres de l'entreprise",
            "identityProviders": "Fournisseurs d'identité",
            "identityProvidersName": "Nom des fournisseurs d'identité",
            "enterpriseIntegrations": "Intégrations d'entreprise",
            "companyInformation": "Informations sur l'entreprise"
        },
        "tabs": {
            "information": "Informations",
            "scim": "Scim",
            "singlesignon": "Single Sign-On"
        },
        "labels": {
            "identityProvider": "Fournisseur d'identité",
            "scimUrl": "URL SCIM",
            "token": "Jeton",
            "enforceSso": "Imposer SSO",
            "identityProviderName": "Nom du fournisseur d'identité",
            "issuerUrl": "URL de l'émetteur",
            "clientId": "ID client",
            "clientSecret": "Secret client",
            "companyName": "Nom de l'entreprise",
            "tenantId": "ID du locataire",
			"dedicatedIpAddresses": "Adresses IP dédiées",
			"dedicatedIpWhitelistInfo": "Ajoutez ces adresses IP à la liste blanche pour autoriser le trafic depuis votre proxy dédié"
        },
        "placeholders": {
            "selectIdentityProvider": "Sélectionner un fournisseur d'identité",
            "scimUrl": "URL SCIM",
            "token": "Jeton",
            "identityProviderName": "Nom du fournisseur d'identité",
            "issuerUrl": "URL de l'émetteur",
            "clientId": "ID client",
            "clientSecret": "Secret client"
        },
        "buttons": {
            "addIdentityProvider": "Ajouter un fournisseur d'identité",
            "regenerateToken": "Régénérer le jeton"
        },
        "messages": {
            "identityProviderDeleted": "Fournisseur d'identité supprimé avec succès.",
            "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer le fournisseur d'identité '{providerName}' ?",
            "configuringIdentityProvider": "Le fournisseur d'identité est en cours de configuration. Cela peut prendre un moment.",
            "updatedIdentityProvider": "Fournisseur d'identité mis à jour avec succès.",
            "ssoUpdated": "Paramètres SSO mis à jour avec succès.",
            "enforceSsoDisabledTooltip": "Ajoutez un fournisseur d'identité pour activer l'application du SSO.",
            "tokenGenerated": "Jeton SCIM généré avec succès.",
            "copied": "Copié dans le presse-papiers.",
            "copyError": "Échec de la copie dans le presse-papiers."
        },
        "validation": {
            "identityProviderRequired": "Le fournisseur d'identité est requis.",
            "issuerUrlRequired": "L'URL de l'émetteur est requise.",
            "clientIdRequired": "L'ID client est requis.",
            "clientSecretRequired": "Le secret client est requis."
        },
        "tooltips": {
            "tokenInfo": "Si vous perdez votre jeton, vous ne pouvez pas le récupérer. Vous devez en créer un nouveau."
        }
    },
    "buttonType": {
        "PRIMARY": "Principal",
        "SECONDARY": "Secondaire",
        "OUTLINE_PRIMARY": "Contour principal",
        "OUTLINE_SECONDARY": "Contour secondaire",
        "OUTLINE_DANGER": "Contour danger",
        "LINK_PRIMARY": "Lien principal",
        "LINK_DANGER": "Lien danger"
    },
    "auditLogs": {
        "title": "Journaux d'audit",
        "selectEntity": "Sélectionner une entité",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "apply": "Appliquer",
        "reset": "Réinitialiser",
        "entity": {
            "users": "Utilisateurs",
            "roles": "Rôles",
            "workflows": "Flux de travail",
            "connections": "Connexions",
            "environments": "Environnements",
            "application": "Application",
            "appVersion": "Version d'application",
            "appResource": "Ressource d'application",
            "roleAssignment": "Attribution de rôle",
            "mcpServer": "Serveur MCP",
            "tenantPrompt": "Prompt du tenant"
        },
        "entityGroup": {
            "platform": "Plateforme",
            "aiApps": "Applications IA"
        },
        "table": {
            "userName": "Nom d'utilisateur",
            "timeStamp": "Horodatage",
            "entity": "Entité",
            "entityName": "Nom",
            "action": "Action",
            "details": "Détails"
        },
        "expansion": {
            "user": "Utilisateur:",
            "dateModified": "Date de modification:",
            "changed": "Modifié:",
            "viewChanges": "Afficher les modifications"
        }
    },
    "filters": {
        "tag": "Tag : {tag}",
        "field": "Champ : {field}",
        "context": "Contexte : {context}",
        "relativeDates": {
            "0_DAY_START": "Début d’aujourd’hui",
            "1_DAY_START": "Début de demain",
            "-1_DAY_START": "Début d’hier",
            "0_WEEK_START": "Début de cette semaine",
            "1_WEEK_START": "Début de la semaine prochaine",
            "-1_WEEK_START": "Début de la semaine dernière",
            "0_MONTH_START": "Début de ce mois",
            "1_MONTH_START": "Début du mois prochain",
            "-1_MONTH_START": "Début du mois dernier",
            "0_QUARTER_START": "Début de ce trimestre",
            "1_QUARTER_START": "Début du trimestre prochain",
            "-1_QUARTER_START": "Début du trimestre dernier",
            "0_YEAR_START": "Début de cette année",
            "1_YEAR_START": "Début de l’année prochaine",
            "-1_YEAR_START": "Début de l’année dernière"
        }
    }
}
